import React from 'react';
import LocationSearchResult from './LocationSearchResult';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { AddressValue } from './Locations';
import { LocationSuggestion } from './utils';
import { RequestState } from 'shared/auth/hooks/useRequestState';

interface LocationSearchResultsProps {
  suggestions: RequestState<LocationSuggestion>;
  selectedAddresses: AddressValue[];
  handleAdd: (address: AddressValue) => unknown;
  handleRemove: (index: number) => unknown;
}

const LocationSearchResults: React.FC<LocationSearchResultsProps> = ({
  suggestions,
  selectedAddresses,
  handleAdd,
  handleRemove,
}) => {
  switch (suggestions.type) {
    case 'REQUEST_START':
      return (
        <LocationSearchResult
          loading={true}
          selectedAddresses={selectedAddresses}
          handleAdd={handleAdd}
          handleRemove={handleRemove}
        />
      );
    case 'REQUEST_SUCCESS':
      return (
        <LocationSearchResult
          loading={false}
          suggestions={suggestions.data}
          selectedAddresses={selectedAddresses}
          handleAdd={handleAdd}
          handleRemove={handleRemove}
        />
      );
    case 'REQUEST_ERROR':
      return <TrueImpactText>{suggestions.error.message}</TrueImpactText>;
    default:
      return null;
  }
};

export default LocationSearchResults;
